import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/basemap/create/basemap.create.mutation.gql"
import type {
  BasemapCreateMutation,
  BasemapCreateMutationVariables,
} from "@/v2-backoffice-client/basemap/create/__types__/basemap.create.mutation"

type Options = MutationHookOptions<
  BasemapCreateMutation,
  BasemapCreateMutationVariables
>

export function useBasemapCreateMutation(options?: Options) {
  return useMutation<BasemapCreateMutation, BasemapCreateMutationVariables>(
    mutation,
    options,
  )
}
